import * as types from "../types/batch.types";
import {
  getBatchList,
  getWalletStackingListbyzone,
  putWalletStackingUpdate,
} from "../../services/batch.service";
import { swalNotification } from "../../components/alret/notificztion";
import { validationErrors } from "../../utils/Helpers";

export const getBatchListAction = (data, navigate) => {
  return async (dispatch, getState) => {
    // console.log("in getBatchListAction: ",getState().authReducer.token)
    try {
      await getBatchList(
        getState().authReducer.token,
        getState().authReducer.user.id
      ).then((res) => {
        // console.log('res.data: ',res.data);
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_BATCH_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const stackingSelectedZoneAction = (zId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: types.SET_STACKING_SELECTED_ZONE,
        payload: zId,
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getWalletStackingManualAction = (data, type) => {
  return async (dispatch, getState) => {
    try {
      await getWalletStackingListbyzone(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data,
        type
      ).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_WALLET_STACKING_M_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getWalletStackingOrderGRiderAction = (data, type) => {
  return async (dispatch, getState) => {
    try {
      await getWalletStackingListbyzone(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data,
        type
      ).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_WALLET_STACKING_O_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getWalletStackingRiderGOrderAction = (data, type) => {
  return async (dispatch, getState) => {
    try {
      await getWalletStackingListbyzone(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data,
        type
      ).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_WALLET_STACKING_R_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const putWalletStackingAction = (type, zid, data) => {
  return async (dispatch, getState) => {
    try {
      await putWalletStackingUpdate(
        getState().authReducer.token,
        getState().authReducer.user.id,
        type,
        zid,
        data
      ).then((res) => {
        if (res.data.code === 200) {
          // console.log(res);
          swalNotification(
            "Wallet Stacking has been updated successfully"
            // res.data.message,
          );
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};
